import { formatIncome, unformatIncome } from 'helpers/money.helper';
import { getGetParam } from './domHelper';
import { isProduction } from 'helpers/env';
import { poll } from './polling.helper';
import { getInjectIovation } from 'helpers/env';

export const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  let angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
};

export const drawCircle = (x, y, radius, startAngle, endAngle) => {
  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);

  var arcSweep = endAngle - startAngle <= 180 ? '0' : '1';

  var d = [
    'M',
    start.x,
    start.y,
    'A',
    radius,
    radius,
    0,
    arcSweep,
    0,
    end.x,
    end.y,
    'L',
    x,
    y,
    'L',
    start.x,
    start.y,
  ].join(' ');

  return d;
};

export const allZero = arr => {
  return arr.reduce((acc, curr) => {
    return acc + curr.score;
  }, 0);
};

export const countNotNulls = data => {
  let nullCount = 0;
  for (let i = 0; i < data.length; i++) {
    if (data[i].score !== null) {
      nullCount++;
    }
  }
  return nullCount;
};

export const grabNonNullCreditScore = data => {
  let creditscore = 0;
  for (let i = 0; i < data.length; i++) {
    if (data[i].score !== null) {
      creditscore = data[i].score;
      return creditscore;
    }
  }
  return creditscore;
};

export const isLetter = str => {
  return str.length === 1 && str.match(/[a-z]/i);
};

export const validateSSN = (ssn, validateEmpty) => {
  if (!validateEmpty && !ssn) {
    return '';
  }
  const regex = /^[0-9]+$/;
  if (regex.test(ssn) && ssn.length === 4) {
    return true;
  } else {
    return 'Please enter a valid 4 digit number';
  }
};

export const validateIncome = (income, notEmpty) => {
  let unformatted = unformatIncome(income);
  if (notEmpty && unformatted === '') {
    return 'Please enter a valid number';
  }
  if (!unformatted) {
    return '';
  }
  const regex = /^[0-9]+$/;
  if (regex.test(unformatted)) {
    return true;
  } else {
    return 'Please enter a valid number';
  }
};

export const validateMarcusIncome = (income, notEmpty) => {
  let unformatted = unformatIncome(income);
  if (notEmpty && unformatted === '') {
    return 'Please enter a valid number';
  }
  if (!unformatted) {
    return '';
  }
  const regex = /^[0-9]+$/;
  if (regex.test(unformatted) && unformatted >= 40000) {
    return true;
  } else {
    return 'Sorry income must be at least $40,000 a year to qualify for a Marcus loan';
  }
};

export const debounce = (func, wait, immediate) => {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const formatIncomeWithNegatives = value => {
  let tempValue = formatIncome(Math.abs(value));
  if (value < 0) {
    tempValue = '-' + tempValue;
  }
  return tempValue;
};

export const filterBusinessTitle = (creditInfo, titles) => {
  const showBusinessTitle = creditInfo?.creditScore >= 530;
  const titleOffersFiltered = titles.filter(item => {
    const text = item?.text || item?.title || item?.titleText;
    return text !== 'Business';
  });
  return showBusinessTitle ? titles : titleOffersFiltered;
};

export const getKeyByValue = (obj, value) => {
  return Object.keys(obj).find(key => obj[key] === value);
};

export const urlSearchParams = (search, get) => {
  const urlSearch = new URLSearchParams(search)?.get(get);
  return urlSearch;
};

export const hasUrlSearchParams = (search, get) => {
  const urlSearch = new URLSearchParams(search)?.has(get);
  return urlSearch;
};

export const getIovationBlackbox = () => {
  const blackboxParam = getGetParam('blackbox');

  if (
    window.IGLOO &&
    typeof window.IGLOO.getBlackbox === 'function' &&
    !blackboxParam
  ) {
    const { blackbox } = window.IGLOO.getBlackbox();
    return blackbox;
  } else if (blackboxParam === 'review' && !isProduction()) {
    return '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';
  } else if (blackboxParam === 'denied' && !isProduction()) {
    return '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';
  } else {
    return null;
  }
};

export const getIovationBlackboxPoll = async () => {
  if (!getInjectIovation()) return null;

  try {
    await poll(() => typeof window.IGLOO.getBlackbox === 'function', 3000);
    return getIovationBlackbox();
  } catch (error) {
    console.error('Blackbox script not available');
    return null;
  }
};

export const checkNeedCapOnePrescreenAcknowledge = array => {
  return array?.some(module => module.needCapOnePrescreenAcknowledge === true);
};
